/* ==========================================================================
   גלריה במסך מלא לצילומי העבודות.
   כל כפתור עם data-lb בעמוד נאסף לפי הסדר. RTL: חץ שמאלה = הבאה.
   ========================================================================== */
(function () {
  'use strict';
  if (!document.querySelector('[data-lb]')) return;

  var ICON_X = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_PREV = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  var ICON_NEXT = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';

  var lb, img, capTag, capTitle, count, items = [], cur = 0, lastFocus = null, touchX = null;

  function build() {
    lb = document.createElement('div');
    lb.className = 'lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'גלריית העבודות');
    lb.innerHTML =
      '<div class="lb__top"><span class="lb__count" aria-live="polite"></span>' +
      '<button class="lb__x" type="button" aria-label="סגירת הגלריה">' + ICON_X + '</button></div>' +
      '<div class="lb__stage">' +
      '<button class="lb__nav lb__prev" type="button" aria-label="התמונה הקודמת">' + ICON_PREV + '</button>' +
      '<img alt="">' +
      '<button class="lb__nav lb__next" type="button" aria-label="התמונה הבאה">' + ICON_NEXT + '</button>' +
      '</div>' +
      '<div class="lb__cap"><span class="tag"></span><b></b></div>';
    document.body.appendChild(lb);

    img = lb.querySelector('.lb__stage img');
    capTag = lb.querySelector('.lb__cap .tag');
    capTitle = lb.querySelector('.lb__cap b');
    count = lb.querySelector('.lb__count');

    lb.querySelector('.lb__x').addEventListener('click', close);
    lb.querySelector('.lb__prev').addEventListener('click', function () { go(cur - 1); });
    lb.querySelector('.lb__next').addEventListener('click', function () { go(cur + 1); });
    // לחיצה על הרקע (לא על התמונה או כפתור) סוגרת
    lb.querySelector('.lb__stage').addEventListener('click', function (e) { if (e.target === this) close(); });
    img.addEventListener('load', function () { img.classList.remove('is-loading'); });

    lb.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) < 45) return;
      // RTL: גרירה ימינה מביאה את התמונה הבאה, שיושבת משמאל
      go(dx > 0 ? cur + 1 : cur - 1);
    });

    lb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur + 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(cur - 1); }
      else if (e.key === 'Tab') trap(e);
    });
  }

  function trap(e) {
    var f = lb.querySelectorAll('button');
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function collect() {
    items = Array.prototype.map.call(document.querySelectorAll('[data-lb]'), function (el) {
      return { el: el, src: el.getAttribute('data-lb'), title: el.getAttribute('data-lb-title') || '', cat: el.getAttribute('data-lb-cat') || '' };
    });
  }

  function go(i) {
    if (!items.length) return;
    cur = (i + items.length) % items.length;
    var it = items[cur];
    img.classList.add('is-loading');
    img.src = it.src;
    img.alt = it.title;
    capTag.textContent = it.cat;
    capTitle.textContent = it.title;
    count.textContent = (cur + 1) + ' / ' + items.length;
    // טעינה מוקדמת של השכנות, כדי שהמעבר יהיה מיידי
    [cur + 1, cur - 1].forEach(function (j) {
      var n = items[(j + items.length) % items.length];
      if (n) { var p = new Image(); p.src = n.src; }
    });
  }

  function open(el) {
    if (!lb) build();
    collect();
    lastFocus = el;
    var i = items.map(function (x) { return x.el; }).indexOf(el);
    go(i < 0 ? 0 : i);
    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { lb.querySelector('.lb__x').focus(); }, 60);
  }

  function close() {
    lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-lb]');
    if (!el) return;
    e.preventDefault();
    open(el);
  });
})();
